import { storeStructure } from '../store/reducers';
import tableLiveTemplate from './tableLiveTemplate';

export default {
  title: 'Live Event Templates',
  attributeName: 'livetemplates',
  getURL: 'livetemplate',
  updateURL: 'liveStatus',
  removeURL: 'livetemplate',
  sessionParams: [],
  noArea: true,
  tableConfig: tableLiveTemplate,
  // sessionWebsocketParams: [],
  autoUpdate: true,
  // websocketNavigation:'users_navigation',
};
